import Advanced from "../components/advanced";

const AdvancedPage = () => {
  return <Advanced />;
};

export default AdvancedPage;